import axios from "axios";
import { baseUrlMasterData } from "../config/api-url.config";

class AutotrimitraMasterServices {
  axios = axios.create({
    baseURL: baseUrlMasterData,
  });

  setToken(token) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  getCreatedBy() {
    const cookieName = "_u_autotrimitrabiz=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return atob(cookie.substring(cookieName.length, cookie.length));
      }
    }
    return null;
  }

  handleError(error) {
    if (error.response) {
      // Server responded with error
      const errorData = error.response.data;
      const errorMessage = errorData?.error?.message || errorData?.messages || error.message || "An error occurred";
      throw new Error(errorMessage);
    } else if (error.request) {
      // Request made but no response
      throw new Error("No response from server. Please check your connection.");
    } else {
      // Something else happened
      throw new Error(error.message || "An error occurred");
    }
  }

  // ==================== GEO AREA - PROVINCE ====================
  async createProvincesBatch(data) {
    try {
      return await this.axios.post("/geo-area/province", {
        data,
        created_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getProvinceByCode(provinceCode) {
    try {
      return await this.axios.get("/geo-area/province", {
        params: { province_code: provinceCode },
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getProvinces(params = {}) {
    try {
      return await this.axios.get("/geo-area/province", { params });
    } catch (error) {
      this.handleError(error);
    }
  }

  // ==================== GEO AREA - CITY ====================
  async createCitiesBatch(data) {
    try {
      return await this.axios.post("/geo-area/city", {
        data,
        created_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getCityByCode(cityCode) {
    try {
      return await this.axios.get("/geo-area/city", {
        params: { city_code: cityCode },
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getCities(params = {}) {
    try {
      return await this.axios.get("/geo-area/city", { params });
    } catch (error) {
      this.handleError(error);
    }
  }

  // ==================== GEO AREA - DISTRICT ====================
  async createDistrictsBatch(data) {
    try {
      return await this.axios.post("/geo-area/district", {
        data,
        created_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getDistrictByCode(districtCode) {
    try {
      return await this.axios.get("/geo-area/district", {
        params: { district_code: districtCode },
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getDistricts(params = {}) {
    try {
      return await this.axios.get("/geo-area/district", { params });
    } catch (error) {
      this.handleError(error);
    }
  }

  // ==================== GEO AREA - SUBDISTRICT ====================
  async createSubdistrictsBatch(data) {
    try {
      return await this.axios.post("/geo-area/subdistrict", {
        data,
        created_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getSubdistrictByCode(subdistrictCode) {
    try {
      return await this.axios.get("/geo-area/subdistrict", {
        params: { subdistrict_code: subdistrictCode },
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getSubdistricts(params = {}) {
    try {
      return await this.axios.get("/geo-area/subdistrict", { params });
    } catch (error) {
      this.handleError(error);
    }
  }


  // ==================== VEHICLE - BRAND ====================
  async createBrandsBatch(data) {
    try {
      return await this.axios.post("/vehicle/brand", {
        data,
        created_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getBrands(params = {}) {
    try {
      return await this.axios.get("/vehicle/brand", { params });
    } catch (error) {
      this.handleError(error);
    }
  }

  // ==================== VEHICLE - MODEL ====================
  async createModelsBatch(data) {
    try {
      return await this.axios.post("/vehicle/model", {
        data,
        created_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async updateModelsBatch(data) {
    try {
      return await this.axios.put("/vehicle/model", {
        data,
        updated_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getModels(params = {}) {
    try {
      return await this.axios.get("/vehicle/model", { params });
    } catch (error) {
      this.handleError(error);
    }
  }

  // ==================== VEHICLE - VARIANT ====================
  async createVariantsBatch(data) {
    try {
      return await this.axios.post("/vehicle/variant", {
        data,
        created_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async updateVariantsBatch(data) {
    try {
      return await this.axios.put("/vehicle/variant", {
        data,
        updated_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getVariants(params = {}) {
    try {
      return await this.axios.get("/vehicle/variant", { params });
    } catch (error) {
      this.handleError(error);
    }
  }


  // ==================== VEHICLE PART - PART TYPE ====================
  async createPartTypesBatch(data) {
    try {
      return await this.axios.post("/vehicle/part-type", {
        data,
        created_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getPartTypes(params = {}) {
    try {
      return await this.axios.get("/vehicle/part-type", { params });
    } catch (error) {
      this.handleError(error);
    }
  }

  // ==================== VEHICLE PART - PART ====================
  async createPartsBatch(data) {
    try {
      return await this.axios.post("/vehicle/part", {
        data,
        created_by: "Autotrimitra - " + this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

  async getParts(params = {}) {
    try {
      return await this.axios.get("/vehicle/part", { params });
    } catch (error) {
      this.handleError(error);
    }
  }

  // ==================== VEHICLE PART - UPDATE DEFAULT PRICE ====================
  async updatePartDefaultPrice(data) {
    try {
      return await this.axios.patch("/vehicle/part/price", {
        data,
        updated_by: this.getCreatedBy(),
      });
    } catch (error) {
      this.handleError(error);
    }
  }

}

export const autotrimitraMasterServices = new AutotrimitraMasterServices();
